import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { Settings2 } from 'lucide-react';

export default function ZohoReportColumnPicker({ allFields, columns, onColumnsChange }) {
  const [open, setOpen] = useState(false);

  const toggle = (field) => {
    const next = columns.includes(field)
      ? columns.filter(f => f !== field)
      : [...columns, field];
    onColumnsChange(next);
  };

  const selectAll = () => onColumnsChange([...allFields]);
  const clearAll = () => onColumnsChange([]);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm" data-testid="report-column-picker" className="gap-1">
          <Settings2 className="h-3.5 w-3.5" />
          Columns ({columns.length})
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-64 max-h-80 overflow-auto" align="end">
        <div className="space-y-1">
          <div className="flex items-center justify-between mb-2">
            <p className="text-xs font-medium text-muted-foreground">Visible columns</p>
            <div className="flex gap-1">
              <Button variant="ghost" size="sm" className="h-6 text-xs px-2" onClick={selectAll}>All</Button>
              <Button variant="ghost" size="sm" className="h-6 text-xs px-2" onClick={clearAll}>None</Button>
            </div>
          </div>
          {allFields.map(f => (
            <div key={f} className="flex items-center gap-2 py-1">
              <Checkbox
                id={`rcol-${f}`}
                checked={columns.includes(f)}
                onCheckedChange={() => toggle(f)}
                data-testid={`rcol-check-${f}`}
              />
              <Label htmlFor={`rcol-${f}`} className="text-sm cursor-pointer flex-1 truncate">{f}</Label>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
